/* eslint-disable react/button-has-type */
import React, { ButtonHTMLAttributes, memo } from 'react';
import useStyles from './styles';

interface IBigButtonNext {
    content: string;
    style?: object;
    type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
    isDisabled?: boolean,
    handleSubmit?: () => void,
}


const BigButtonNext : React.FC<IBigButtonNext> = ({
  content, type = 'button', isDisabled = false, style, handleSubmit,
}) => {
  const classes = useStyles();
  const handleClick = () => {
    handleSubmit && handleSubmit();
  };
  return (
    <button type={type} className={classes.btn} disabled={isDisabled} style={style || {}} onClick={handleClick}>
      <span>{content}</span>
      <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.932 9.952L1.66 0.711999L0.82 1.888L12.412 9.952V10.048L0.82 18.112L1.66 19.288L14.932 10.048V9.952ZM22.18 9.952L8.908 0.711999L8.092 1.888L19.66 9.952V10.048L8.092 18.112L8.908 19.288L22.18 10.048V9.952Z" fill="white" />
      </svg>
    </button>
  );
};

export default memo(BigButtonNext);
